export default __webpack_public_path__ + "static/Feedback-6ecb2fb12904a634e6e5514cdaf5ced8.webm";